
import { motion } from "framer-motion";
import DownloadPopup from "@/components/DownloadPopup";

const CallToAction = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="text-center pt-8"
    >
      <div className="max-w-xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold mb-6">Ready to jump into the action?</h2>
        <DownloadPopup buttonText="Play Now" />
      </div>
    </motion.div>
  );
};

export default CallToAction;
